import App from '../components/ProjectFeedback/App';
function Feedback() {
  return <App />;
}

export default Feedback;
